import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        textos: (_a = {
                position: 'absolute',
                top: '-40px',
                textAlign: 'center',
                width: 'max-content'
            },
            _a[theme.breakpoints.down('sm')] = {
                transform: 'translate(85px, 45px)',
                textAlign: 'start',
            },
            _a),
        fecha: {
            color: 'var(--gris-l43)',
        },
        amarillo: {
            color: 'var(--amarillo-l44)',
        },
        verdeClaro: {
            color: 'var(--verde-exito)',
        },
        verdeOscuro: {
            color: 'var(--verde-l33)',
        },
        rojo: {
            color: 'var(--rojo-error)',
        },
        grisL93: {
            color: 'var(--gris-l93)',
        },
        grisL83: {
            color: 'var(--gris-l83)',
        },
        grisL63: {
            color: 'var(--gris-l63)',
        },
        grisL43: {
            color: 'var(--gris-l43)',
        },
    });
});
export default useStyles;
